// Ported from design/project/App74-DepositAddress.dc.html, then wired to the vault address and the player's memo.
import { useState } from "react";
import { useMoney } from "../money.js";
import { go } from "../router.js";
import { tg } from "../telegram.js";
import { DepositTabs, Line, SheetBackdrop, SheetTitle } from "./money-parts.js";

export function CopyButton({ text, label }: { text: string | null | undefined; label: string }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Older Telegram webviews block the clipboard: select the text so a long press copies it.
      const r = document.createRange();
      const node = document.querySelector(`[data-copy="${label}"]`);
      if (node) {
        r.selectNodeContents(node);
        getSelection()?.removeAllRanges();
        getSelection()?.addRange(r);
      }
      return;
    }
    tg?.HapticFeedback?.notificationOccurred("success");
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return <button onClick={() => void copy()} aria-label={`Copy ${label}`} className="chip chipL" style={{ height: "30px", border: "0", cursor: "pointer", fontFamily: "Inter, sans-serif", flex: "none", minWidth: "64px", justifyContent: "center" }}>{copied ? "COPIED" : "COPY"}</button>;
}

export function App74_DepositAddress() {
  const { view } = useMoney();
  const vault = view?.deposit.vault;
  const memo = view?.deposit.memo;
  const left = view ? Number(view.deposit.left).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "...";
  const sent = () => {
    sessionStorage.setItem("dd:pendingDeposit", JSON.stringify({ amount: null, at: Date.now(), from: null }));
    go("App55", true);
  };

  return (
    <>
      <div className="screen">
  <SheetBackdrop />
  <div className="sheet g squeeze" style={{ background: "rgba(18,22,29,0.96)", borderBottom: "0" }}>
    <SheetTitle>Deposit USDT</SheetTitle>
    <DepositTabs active="address" />
    <p className="muted" style={{ margin: "12px 0 0", fontSize: "13px", lineHeight: "19px" }}>From @wallet, Binance, Bybit or any TON wallet. No TON needed.</p>

    <div className="g" style={{ marginTop: "12px", borderRadius: "18px", padding: "14px", display: "flex", flexDirection: "column", gap: "12px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <span className="lbl">1 · SEND TO THIS ADDRESS</span>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}><span data-copy="address" className="mono" style={{ flex: "1", minWidth: "0", fontSize: "12px", lineHeight: "17px", overflowWrap: "anywhere", userSelect: "all" }}>{vault ?? "..."}</span><CopyButton text={vault} label="address" /></div>
      </div>
      <div className="div"></div>
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <span className="lbl">2 · ADD THIS COMMENT (MEMO)</span>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}><span data-copy="memo" className="mono lime" style={{ flex: "1", minWidth: "0", fontSize: "18px", fontWeight: "800", overflowWrap: "anywhere", userSelect: "all" }}>{memo ?? "..."}</span><CopyButton text={memo} label="memo" /></div>
        <span className="muted" style={{ fontSize: "11px", lineHeight: "16px" }}>Without it we can't tell the deposit is yours, and it waits for support.</span>
      </div>
    </div>

    <div style={{ marginTop: "10px", display: "flex", gap: "10px", alignItems: "flex-start", padding: "12px 14px", borderRadius: "16px", background: "rgba(255,51,102,0.08)", border: "1px solid rgba(255,51,102,0.35)" }}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF3366" strokeWidth="2.2" strokeLinecap="round" style={{ flex: "none" }} aria-hidden="true"><path d="M12 3 L22 20 H2 Z"></path><path d="M12 10v4M12 17v.5"></path></svg>
      <span style={{ fontSize: "12px", lineHeight: "17px" }}>Only <b>USDT on the TON network</b>. USDT sent on TRON, BNB Chain or Ethereum can't be recovered.</span>
    </div>

    <div className="g" style={{ marginTop: "10px", borderRadius: "18px", padding: "4px 0" }}>
      <Line first label="Minimum deposit"><span className="mono">{view?.deposit.min ?? "2.00"} USDT</span></Line>
      <Line label="Arrives in balance">about a minute after it's sent</Line>
      <Line label="Balance limit"><span className="mono">10,000</span> · <span className="mono">{left}</span> left</Line>
    </div>

    <button onClick={sent} className="btnP" style={{ marginTop: "14px", border: "0", cursor: "pointer" }}>DONE, I'VE SENT IT</button>
  </div>
</div>
    </>
  );
}
